export default {
  buildings: [],
  filters: {},
  paginationOptions: {}
};
